function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.01,
    height: 13.608,
    viewBox: "0 0 17.01 13.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16310",
    d: "M18 5.78A2.089 2.089 0 0 0 15.942 4H3.116a2.089 2.089 0 0 0-2.06 1.78l8.473 5.483z",
    transform: "translate(-1.024 -4)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16311",
    d: "M9.813 14.789a.567.567 0 0 1-.616 0L1 9.486v8.406a2.094 2.094 0 0 0 2.092 2.092h12.826a2.094 2.094 0 0 0 2.092-2.092V9.485z",
    transform: "translate(-1 -6.375)",
    style: {
      fill: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8494c72237d041abb2a884f17bcd7403.svg";
export { ForwardRef as ReactComponent };